import {SET_GUIDE_TITLE, SET_TOC_VISIBILITY} from "../actionTypes";

const initialState = {
    title: '',
    isTocVisible: false,
};

export default function (state = initialState, action) {
    switch (action.type) {
        case SET_GUIDE_TITLE:
            return {
                ...state,
                title: action.payload
            };
        case SET_TOC_VISIBILITY:
            return {
                ...state,
                isTocVisible: action.payload
            };

        default:
            return state;
    }
}
